import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ToggleRadioButtonGroup,
  type ToggleRadioButtonGroupProps,
} from '~/components/elements/ToggleRadioButtonGroup'

type SortDirection = 'asc' | 'desc'

export type SortSwitcherProps = {
  disabled?: boolean
  onChange?: (value: SortDirection) => void
  value: SortDirection | null
}

export const SortSwitcher = ({
  disabled,
  onChange,
  value,
}: SortSwitcherProps) => {
  const { t } = useTranslation()

  const attributes: ToggleRadioButtonGroupProps<SortDirection>['attributes'] =
    React.useMemo(
      () => [
        { text: t('ascending'), value: 'asc' },
        { text: t('descending'), value: 'desc' },
      ],
      [t],
    )

  return (
    <ToggleRadioButtonGroup
      attributes={attributes}
      disabled={disabled}
      value={value ?? undefined}
      onChange={onChange}
    />
  )
}
